module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAMAAAAYXScKAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABLUExURUdwTBdr9hdr9Rhs9hhs9hds9Rds9gls/xhs9RRn+Bls9xdr9Rds9Rdr9Rhp9xds9Rds9hds9hds9Rhr9Rdr9Rdr9Rdq9Blr9Rdr9Wbdn6YAAAAZdFJOUwDAZ8rT+d0F/gkTJnToHbdZQp+pfpI5TYZMJFf3AAAAr0lEQVQY02XRjQ7EEAwA4PpvZ2Zj2+39n/SU3OZGIurTIgD8mgwShiYxoRxRlr7+41rzLnOOCLPZOvzg3HAdUVakpeGGOw9nXSOBW4cAyXggbTOzx6tkJFc4G68tQcYTwsF1RnN2xkBlOAKoGixGMe8cU0jguOhmRhvLdtTYG9Ehs24c60RQq5ms5mVf7utuZFa1Cpx6kFkwO6Gm/tEW5jcyR4pvLGeFoKfx4/zx4BdxAgaybGW02wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header/select-title4.png
// module id = yLKO
// module chunks = 0